import { IModal } from "./type"
import { Modal } from "react-bootstrap"
import styles from './modal.styles.module.scss'
import { CloseIcon } from "./icon"

const HRMSModal = (props: IModal) => {
    const { show, onClose, children, title, footer, isShowHeader, ...other } = props
    return (
        <Modal show={show} onHide={onClose} {...other}>
            {isShowHeader &&
                <Modal.Header>
                    <Modal.Title className={`${styles.modalTitle}`}>{title}</Modal.Title>
                    <CloseIcon
                        className={`${styles.closeIcon}`}
                        onClick={onClose}
                    />
                </Modal.Header>
            }
            <Modal.Body>
                {children}
            </Modal.Body>
            {
                footer &&
                <Modal.Footer className="d-block">
                    {footer}
                </Modal.Footer>
            }
        </Modal>
    );
}

export default HRMSModal